<script setup lang="ts">
const localePath = useLocalePath()
</script>

<template>
  <div class="sidebar left">
    <div class="menuCss4">
      <ul class="MenuBar MenuBarActive">
        <li class="item29 selected first last rank0 parent">
          <NuxtLink :to="localePath('products-products')">
            <span class="icon">
              <svg xmlns="http://www.w3.org/2000/svg"
                   viewBox="0 0 320 512">
                <path d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z" />
              </svg>
            </span>
            <span>
              {{ $t('navigation.products.name') }}
            </span>
          </NuxtLink>
          <div class="itemChildDiv29 selected">
            <ul class="itemChild29 selected">
              <li class="item14 first rank0">
                <NuxtLink :to="localePath('products-consumerMarket')">
                  {{ $t('navigation.consumerMarket.name') }}
                </NuxtLink>
              </li>
              <li class="item15 rank1">
                <NuxtLink :to="localePath('products-awayFromHomeMarket')">
                  {{ $t('navigation.awayFromHomeMarket.name') }}
                </NuxtLink>
              </li>
              <li class="item12 rank2">
                <NuxtLink :to="localePath('products-privateLabelMarket')">
                  {{ $t('navigation.privateLabelMarket.name') }}
                </NuxtLink>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss"></style>
